"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EFolderStatus;
(function (EFolderStatus) {
    EFolderStatus["LIVE"] = "LIVE";
    EFolderStatus["ARCHIVED"] = "ARCHIVED";
})(EFolderStatus || (EFolderStatus = {}));
exports.default = EFolderStatus;
